import "../assets/styles/Footer.css";

const Footer = () => {
    return (
        <div className="footer">
       <p className="footer-ft sticky bottom-0"> created by <a href='https://twitter.com/VeldaKiara'> <b> <u> Velda Kiara </u></b> </a> - devChallenges.io </p>
        </div>
    );
}
export default Footer;